"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSpeechContext = void 0;
var react_1 = require("react");
var context_1 = require("./context");
/**
 * React hook that exposes SpeechContext.
 * This is just an alias for useContext(SpeechContext).
 * @public
 */
function useSpeechContext() {
    return react_1.useContext(context_1.SpeechContext);
}
exports.useSpeechContext = useSpeechContext;
